
import { Navbar } from "@/components/Navbar";

export default function Terms() {
  return (
    <>
      <Navbar />
      <div className="container mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none">
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Introduction</h2>
          <p>
            Welcome to VitaWellness. These Terms of Service govern your use of our website, mobile application,
            and services. By accessing or using VitaWellness, you agree to be bound by these Terms.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Definitions</h2>
          <p>
            <strong>"Service"</strong> refers to the VitaWellness platform, including website, mobile applications, and related services.<br />
            <strong>"User"</strong> refers to individuals who register and use the VitaWellness service.<br />
            <strong>"Content"</strong> refers to text, graphics, images, music, software, audio, video, information or other materials.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Account Registration</h2>
          <p>
            To use certain features of the Service, you must register for an account. You agree to provide accurate,
            current, and complete information during the registration process and to update such information to keep it
            accurate, current, and complete.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Subscription and Payments</h2>
          <p>
            VitaWellness offers subscription plans for premium features. By subscribing to a premium plan, you agree to pay 
            all fees associated with your subscription. Payments are non-refundable except as required by law or as 
            explicitly stated in these Terms.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">5. User Content</h2>
          <p>
            Users may create, upload, post, send, receive, and store content. By providing content to the Service, you grant
            VitaWellness a non-exclusive, worldwide, royalty-free, sublicensable, and transferable license to use, copy, modify,
            create derivative works from, distribute, publicly display, and perform such content.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Privacy</h2>
          <p>
            Our privacy practices are set forth in our Privacy Policy, which is incorporated into these Terms by reference.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Disclaimers</h2>
          <p>
            The Service is provided "as is" and "as available" without warranties of any kind, either express or implied.
            VitaWellness does not warrant that the Service will be uninterrupted or error-free.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, VitaWellness shall not be liable for any indirect, incidental, special,
            consequential, or punitive damages, or any loss of profits or revenues.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">9. Governing Law</h2>
          <p>
            These Terms shall be governed by the laws of [Jurisdiction], without regard to its conflict of law provisions.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">10. Changes to Terms</h2>
          <p>
            VitaWellness reserves the right to modify these Terms at any time. We will provide notice of significant changes
            through the Service or by other means.
          </p>

          <p className="mt-12 mb-6">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </>
  );
}
